import toast from 'react-hot-toast';
import palette from 'theme/palette';

export const showToast = {
  success: (message) => toast.success(message),
  error: (message) => toast.error(message),
  warning: (message) => toast(message, {
    style: {
      background: palette.toastWarningBg,
      color: palette.white,
    },
  }),
  info: (message) => toast(message),
};
